import { CardRail } from '@r-client/republic/ui/offerings';

import { LOADING_LABEL, SLIDE_WIDTH } from '../constants';
import { CryptoAssetCardPlaceholder } from './crypto-asset-card-placeholder';

/**
 * Slides rendered while loading — anything past the fold is invisible cost.
 * Five rather than the deal rail's four: these tiles are 248px, so more of them
 * sit above the fold.
 */
const PLACEHOLDER_COUNT = 5;

/**
 * The same `CardRail` the loaded section uses, so the placeholders sit on the
 * identical geometry and the rail doesn't shift when the cards arrive.
 */
export const CryptoRailSkeleton = () => (
  <CardRail
    role="status"
    ariaLabel={LOADING_LABEL}
    slideWidth={SLIDE_WIDTH}
    scrollable={false}
  >
    {Array.from({ length: PLACEHOLDER_COUNT }, (_, index) => (
      <CryptoAssetCardPlaceholder key={index} />
    ))}
  </CardRail>
);
